import {
  actions,
  ClearButtonBehaviour,
  InputButton,
  KeyMap,
  MultilineTextInput,
  MultilineTextInputProps,
} from '@infotech-soe/erp-ui-kit';
import React from 'react';

import { DictMultilineFormControlViewModel } from '../../../services/form/view-model/FormControlViewModel';

import { TFormControlConnectorProps } from './FormControlContainer';
import FormLabeledInputControl from './FormLabeledInputControl';
import FormTextControl from './hoc/FormTextControl';
import { RequiredHistoryProps } from './hoc/HistoryContainer';
import { useDictionaryControl } from './useDictionaryControl';

type Props = TFormControlConnectorProps &
  Partial<RequiredHistoryProps<HTMLTextAreaElement>> &
  Pick<MultilineTextInputProps, 'value' | 'onValidate'> & {
    control: DictMultilineFormControlViewModel;
  };

const FormDictMultilineTextInputControl = (props: Props) => {
  const {
    areHintsShown,
    control,
    value,
    onChange,
    onChanged,
    onSubmit,
    onValidate,
  } = props;
  const onButtonClick = useDictionaryControl(props);

  return (
    <FormLabeledInputControl areHintsShown={areHintsShown} control={control}>
      <MultilineTextInput
        canClearOnReadOnly={control.canClearOnReadOnly}
        allowTextOverflow
        className="col"
        keymap={
          control.hideDictionaryButton
            ? undefined
            : { [KeyMap[actions.CONTROL_POPUP]]: onButtonClick }
        }
        disabled={control.disabled}
        lengthInBytes={control.lengthInBytes}
        maxLength={control.maxLength}
        name={control.name}
        readOnly={control.readonly}
        required={control.required}
        rows={control.rows}
        value={value}
        withFillProgress
        onChange={onChange}
        onChanged={onChanged}
        onSubmit={onSubmit}
        withClearButton={ClearButtonBehaviour.ALWAYS}
        onValidate={onValidate}
      >
        {!control.hideDictionaryButton && (
          <InputButton
            icon="ellipsis"
            onClick={onButtonClick}
            disabled={
              control.disabled ||
              (control.readonly && !control.enableButtonOnReadOnly)
            }
          />
        )}
      </MultilineTextInput>
    </FormLabeledInputControl>
  );
};

export default FormTextControl(FormDictMultilineTextInputControl);
